import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-m-quick-order-line-edit',
    templateUrl: './m-quick-order-line-edit.component.html',
    styleUrls: ['./m-quick-order-line-edit.component.scss']
})
export class MQuickOrderLineEditComponent implements OnInit {

    public savedData: {[key: string]: any} = {};
    public invalidScan = false;

    @Output() onUpdate = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<MQuickOrderLineEditComponent>
    ) {
    }

    ngOnInit() {
        this.savedData = {
            ID: this.data.scan.ID,
            CO1_ID: this.data.scan.CO1_ID,
            CONTRACT_BIN_ID: this.data.scan.CONTRACT_BIN_ID,
            CONTRACT_BIN_ID_ORIGINAL: this.data.scan.CONTRACT_BIN_ID,
            ITEM_ID: this.data.scan.ITEM_ID,
            RA1_SHIP_TO_NAME: this.data.scan.RA1_SHIP_TO_NAME,
            CU1_NAME: this.data.scan.CU1_NAME,
            CO1_NAME: this.data.scan.CO1_NAME,
            PO_NUMBER: this.data.scan.PO_NUMBER,
            JOB_NUMBER: this.data.scan.JOB_NUMBER,
            QUANTITY: Number(this.data.scan.QUANTITY),
            MD1_PRICE: Number(this.data.scan.MD1_PRICE),
            MD1_UM: this.data.scan.MD1_UM,
            MD1_UM_SIZE: Number(this.data.scan.MD1_UM_SIZE),
            MD1_REORDER_QTY: Number(this.data.scan.MD1_REORDER_QTY),
            MD1_MIN_QTY: Number(this.data.scan.MD1_MIN_QTY),
            TOTAL_PRICE: Number(this.data.scan.TOTAL_PRICE)
        };
        this.invalidScan = this.data.invalidScan;
        this.computeTotalValue();
    }

    increaseQty() {
        this.savedData.QUANTITY += Number(this.savedData.MD1_REORDER_QTY);
        this.computeTotalValue();
    }

    decreaseQty() {
        this.savedData.QUANTITY -= Number(this.savedData.MD1_REORDER_QTY);
        if (this.savedData.QUANTITY < Number(this.savedData.MD1_MIN_QTY)) {
            this.savedData.QUANTITY = Number(this.savedData.MD1_MIN_QTY);
        }
        this.computeTotalValue();
    }

    onUpdateClick() {
        this.onUpdate.emit(this.savedData);
        this.closeDialog();
    }

    onCancelClick() {
        this.closeDialog();
    }

    private computeTotalValue() {
        if (Number(this.savedData.MD1_UM_SIZE) === 0) {
            this.savedData.TOTAL_PRICE = Number(this.savedData.MD1_PRICE) * Number(this.savedData.QUANTITY);
        } else {
            this.savedData.TOTAL_PRICE = (Number(this.savedData.MD1_PRICE) / Number(this.savedData.MD1_UM_SIZE))
                * Number(this.savedData.QUANTITY);
        }
    }

    private closeDialog() {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/quick-order/quick-order-line-edit/m-quick-order-line-edit.component.ts